
import React from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import MultiStatusFilter from "./MultiStatusFilter";
import ActiveFiltersDisplay from "./ActiveFiltersDisplay";
import { useIsMobile } from "@/hooks/use-mobile";

interface NotificationFiltersProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  unreadFilter?: boolean;
  toggleUnreadFilter?: () => void;
  unreadCount?: number;
  selectedStatuses?: string[];
  onStatusChange?: (statuses: string[]) => void;
}

const NotificationFilters = ({ 
  searchTerm, 
  setSearchTerm,
  unreadFilter,
  toggleUnreadFilter,
  unreadCount = 0,
  selectedStatuses = [],
  onStatusChange = () => {}
}: NotificationFiltersProps) => {
  const isMobile = useIsMobile();

  const handleRemoveStatus = (status: string) => {
    onStatusChange(selectedStatuses.filter(s => s !== status));
  };

  const handleClearAll = () => {
    onStatusChange([]);
  };

  return (
    <div className="space-y-2">
      <div className={`flex ${isMobile ? 'flex-col' : 'flex-col sm:flex-row'} gap-2`}>
        <div className="relative flex-grow">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            type="search"
            placeholder="Zoek op VO-nummer of bericht..."
            className={`pl-8 ${isMobile ? 'h-10 rounded-lg' : ''}`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        
        <div className={`flex ${isMobile ? 'flex-col' : 'flex-wrap'} gap-2`}>
          {onStatusChange && (
            <MultiStatusFilter
              selectedStatuses={selectedStatuses}
              onStatusChange={onStatusChange}
              className={isMobile ? 'h-10' : ''}
            />
          )}
          
          {toggleUnreadFilter && (
            <Button 
              variant={unreadFilter ? "secondary" : "outline"}
              onClick={toggleUnreadFilter}
              className={`whitespace-nowrap ${isMobile ? 'justify-start h-10' : ''}`}
              size={isMobile ? "sm" : "default"}
            >
              Ongelezen 
              {unreadCount > 0 && (
                <Badge variant="default" className="ml-2 bg-blue-500">
                  {unreadCount}
                </Badge>
              )}
            </Button>
          )}
        </div>
      </div>
      
      <ActiveFiltersDisplay
        selectedStatuses={selectedStatuses}
        onRemoveStatus={handleRemoveStatus}
        onClearAll={handleClearAll}
      />
    </div>
  );
};

export default NotificationFilters;
